import asLazyPage from 'hocs/asLazyPage';

export const Login = asLazyPage(() => import('pages/login'));

export const Registration = asLazyPage(() => import('pages/registration'));

export const ForgotPassword = asLazyPage(() => import('pages/forgotPassword'));

export const ResetPassword = asLazyPage(() => import('pages/resetPassword'));

export const Home = asLazyPage(() => import('pages/home'));

export const ProcessDefinitionCreateForm = asLazyPage(
  () => import('pages/processDefinitionCreateForm')
);

export const ProcessDefinitionCreateSecurityGroup = asLazyPage(
  () => import('pages/processDefinitionCreateSecurityGroup')
);

export const ProcessEditor = asLazyPage(() => import('pages/processEditor'));

export const ProcessEditorForms = asLazyPage(
  () => import('pages/processEditorForms')
);

export const ProcessEditorFormDetails = asLazyPage(
  () => import('pages/processEditorFormDetails')
);

export const ProcessEditorFormManage = asLazyPage(
  () => import('pages/processEditorFormManage')
);

export const ProcessDefinition = asLazyPage(
  () => import('pages/processDefinition')
);

export const ProcessDefinitionDetails = asLazyPage(
  () => import('pages/processDefinitionDetails')
);

export const ProcessDefinitionVersions = asLazyPage(
  () => import('pages/processDefinitionVersions')
);

export const ProcessDefinitionSecurity = asLazyPage(
  () => import('pages/processDefinitionSecurity')
);

export const ProcessDefinitionDataModelFields = asLazyPage(
  () => import('pages/processDefinitionDataModelFields')
);

export const ProcessDefinitionAdjacentDocuments = asLazyPage(
  () => import('features/adjacentDocuments/configuration')
);

export const ProcessDefinitionVersionFields = asLazyPage(
  () => import('pages/processDefinitionVersionFields')
);

export const ProcessDefinitionForms = asLazyPage(
  () => import('pages/processDefinitionForms')
);

export const ProcessDefinitionFormDetails = asLazyPage(
  () => import('pages/processDefinitionFormDetails')
);

export const ProcessDefinitionScanning = asLazyPage(
  () => import('pages/processDefinitionScanning')
);

export const ProcessManagement = asLazyPage(
  () => import('pages/processManagement')
);

export const ProcessManagementDetails = asLazyPage(
  () => import('features/processExecution/processManagementDetails')
);

export const ProcessInstance = asLazyPage(
  () => import('pages/processInstance')
);

export const ProcessInstanceEditor = asLazyPage(
  () => import('pages/processInstanceEditor')
);

export const ProcessDefinitionScanningDetails = asLazyPage(
  () => import('pages/processDefinitionScanningDetails')
);

export const ProcessManagementScanningScenarioOld = asLazyPage(
  () => import('pages/processManagementScanningScenarioOld')
);

export const ProcessManagementScanningScenario = asLazyPage(
  () => import('features/indexing/pages/execution')
);

export const ProcessExecutionOrderEntry = asLazyPage(
  () => import('features/orderEntry/execution')
);

export const ProcessExecutionMaintenancePayables = asLazyPage(
  () => import('features/maintenancePayables/execution')
);

export const ProcessExecutionGeneralPayables = asLazyPage(
  () => import('features/generalPayables/execution')
);

export const ProcessDefinitionPrintRender = asLazyPage(
  () => import('pages/processDefinitionPrintRender')
);

export const ProcessDefinitionOrderEntry = asLazyPage(
  () => import('features/orderEntry/scenario')
);

export const ProcessDefinitionAutomatedIndexing = asLazyPage(
  () => import('pages/processDefinitionAutomatedIndexing')
);

export const ProcessDefinitionAutomatedIndexingCreateAndEditScenario =
  asLazyPage(
    () =>
      import('pages/processDefinitionAutomatedIndexingCreateAndEditScenario')
  );

export const ProcessDefinitionMaintenancePayables = asLazyPage(
  () => import('features/maintenancePayables/scenario')
);

export const ProcessDefinitionGeneralPayables = asLazyPage(
  () => import('features/generalPayables/scenario')
);

export const ProcessDefinitionGeneralPayablesApprovals = asLazyPage(
  () => import('features/generalPayablesApproval/definition')
);

export const Management = asLazyPage(() => import('pages/management'));

export const ManagementUsers = asLazyPage(
  () => import('pages/managementUsers')
);

export const ManagementInvitations = asLazyPage(
  () => import('pages/managementInvitations')
);

export const ManagementUserLogs = asLazyPage(
  () => import('pages/managementUserLogs')
);

export const ManagementTenants = asLazyPage(
  () => import('pages/managementTenants')
);

export const ManagementConnections = asLazyPage(
  () => import('pages/managementConnections')
);

export const ManagementConnectionsDetails = asLazyPage(
  () => import('pages/managementConnectionsDetails')
);

export const PrintRenderDetails = asLazyPage(
  () => import('pages/printRenderDetails')
);

export const PrintRenderDetailsOverrideConfig = asLazyPage(
  () => import('pages/printRenderDetailsOverrideConfig')
);

export const PrintRenderResultDetailsPrintFile = asLazyPage(
  () => import('pages/printRenderResultDetailsPrintFile')
);

export const ExternalForm = asLazyPage(() => import('pages/externalForm'));

export const ExternalFormSubmitted = asLazyPage(
  () => import('pages/externalFormSubmitted')
);

export const EmailPolling = asLazyPage(() => import('pages/emailPolling'));

export const ProcessDefinitionEmailTemplates = asLazyPage(
  () => import('pages/processDefinitionEmailTemplates')
);

export const ProcessDefinitionIndexingSource = asLazyPage(
  () => import('pages/processDefinitionIndexingSource')
);

export const SplitDocuments = asLazyPage(() => import('pages/splitDocuments'));

export const SystemLogs = asLazyPage(() => import('pages/systemLogs'));

export const ProcessEditorEmailTemplates = asLazyPage(
  () => import('pages/processEditorEmailTemplates')
);

export const FtpPolling = asLazyPage(() => import('pages/ftpPolling'));

export const ProcessExecutionStatus = asLazyPage(
  () => import('pages/processExecutionStatus')
);

export const ProcessInstanceCreation = asLazyPage(
  () => import('pages/processInstanceCreation')
);

export const UserAgreements = asLazyPage(() => import('pages/agreements'));

export const PostOIDC = asLazyPage(() => import('pages/oidc/landingPage'));

export const PreOIDCLink = asLazyPage(
  () => import('pages/oidc/linking/preLinkPage')
);

export const PostOIDCLink = asLazyPage(
  () => import('pages/oidc/linking/postLinkPage')
);

export const BarcodeImporter = asLazyPage(
  () => import('pages/barcodeImporter')
);

export const PostEmailLink = asLazyPage(
  () => import('pages/managementConnections/connections/email/postLink')
);

export const OrderEntryDetails = asLazyPage(
  () => import('features/orderEntry/filesAndLogs')
);

export const MaintenancePayablesDetails = asLazyPage(
  () => import('features/maintenancePayables/filesAndLogs')
);

export const GeneralPayablesDetails = asLazyPage(
  () => import('features/generalPayables/filesAndLogs')
);

export const ProcessDefinitionDriverSettlements = asLazyPage(
  () => import('features/driver-settlements/pages/configuration')
);

export const DriverSettlements = asLazyPage(
  () => import('features/driver-settlements/pages/execution')
);
